export default __webpack_public_path__ + "static/media/boom.d89f41a5.wav";